import { GameConstants } from "../../GameConstants";
import { GameVars } from "../../GameVars";
import { SplashScene } from "./SplashScene";

export class FirstSessionLayer extends Phaser.GameObjects.Container {

    constructor(scene: Phaser.Scene) {
        
        super(scene);

        const gameText = this.scene.cache.json.get("text");
        const lan = GameVars.gameData.data.language;

        const darkLayer = new Phaser.GameObjects.Graphics(this.scene);
        darkLayer.fillStyle(0x2c241f, 1);
        darkLayer.alpha = .5;
        darkLayer.fillRect(0, 0, GameConstants.GAME_WIDTH, GameConstants.GAME_HEIGHT);
        this.add(darkLayer);

        const scaledItemsContainer = new Phaser.GameObjects.Container(this.scene, GameConstants.GAME_WIDTH / 2, GameConstants.GAME_HEIGHT / 2);
        scaledItemsContainer.scaleX = GameVars.scaleX;
        this.add(scaledItemsContainer);

        const tutorialImg = new Phaser.GameObjects.Image(this.scene, 0, 0, "texture_atlas_4", "tutorial_1");
        scaledItemsContainer.add(tutorialImg);

        const label1 = new Phaser.GameObjects.Text(this.scene, 0, -170, gameText.PLAY_DAILY_UNLOCK_CATS_BOARDS[lan], {fontFamily: "OpenSans-CondLight", fontSize: "28px", color: "#A17A65"});
        label1.setOrigin(.5);
        scaledItemsContainer.add(label1);

        if (label1.width > 750) {
            label1.setScale(750 / label1.width);
        }

        const label2 = new Phaser.GameObjects.Text(this.scene, -275, -98, gameText.DAILY_GAMES[lan], {fontFamily: "OpenSans-CondLight", fontSize: "24px", color: "#A17A65"});
        scaledItemsContainer.add(label2);

        const label3 = new Phaser.GameObjects.Text(this.scene, 90, label2.y, gameText.ALL_BOARDS[lan], {fontFamily: "OpenSans-CondLight", fontSize: "24px", color: "#A17A65"});
        scaledItemsContainer.add(label3);

        const label4 = new Phaser.GameObjects.Text(this.scene, -285, 95, gameText.BOARD_CLEARED[lan], {fontFamily: "OpenSans-CondLight", fontSize: "24px", color: "#A17A65"});
        scaledItemsContainer.add(label4);

        const label5 = new Phaser.GameObjects.Text(this.scene, 180, 100, gameText.CLASSIC[lan], {fontFamily: "OpenSans-CondLight", fontSize: "20px", color: "#A17A65"});
        label5.setOrigin(.5);
        scaledItemsContainer.add(label5);

        this.scene.input.on("pointerdown", this.onPointerDown, this);

        this.alpha = 0;

        this.scene.tweens.add({
            targets: this,
            alpha: 1,
            duration: 500,
            delay: 4500,
            ease: Phaser.Math.Easing.Cubic.Out
        });
    }

    private onPointerDown(): void {

        this.scene.input.off("pointerdown", this.onPointerDown, this);

        SplashScene.currentInstance.removeFirstSessionLayer();
    }
}
